import { SamdFakeAppRepository } from '@samd/api/fake_app_repository';
import { SamdFakeMemberRepository } from '@samd/api/fake_member_repository';
import { SamdFakeOrderRepository } from '@samd/api/fake_order_repository';
import { SamdGraphqlAppRepository } from '@samd/api/graphql_app_repository';
import { SamdGraphqlOrderRepository } from '@samd/api/graphql_order_repository';
import { SamdOrderRepository } from '@samd/api/order_repository';
import { SamdProstateOrderDetailDisplayer } from '@samd/features/orders';
import { AppRepository } from 'src/api/app_repository';
import { GraphqlClient } from 'src/api/graphql_client';
import { MemberRepository } from 'src/api/member_repository';
import { OrderDetailDisplayer } from 'src/distribution_platforms/features/order_details';
import {
  InstanceFactory,
  BaseInstanceFactory,
} from 'src/distribution_platforms/features/utils/base_instance_factory';
import { Region, RepoBackend } from 'src/types/env';
import { GraphqlClientRequiredError } from 'src/types/errors';

/**
 * Instance factory for the SaMD platform.
 */
export class SamdInstanceFactory
  extends BaseInstanceFactory
  implements InstanceFactory
{
  constructor(readonly _repoBackend: RepoBackend) {
    super(_repoBackend);
  }

  createAppRepository(graphqlClient: GraphqlClient): AppRepository {
    if (this._repoBackend === RepoBackend.Fake) {
      return new SamdFakeAppRepository();
    } else {
      if (!graphqlClient) {
        throw new GraphqlClientRequiredError();
      }
      return new SamdGraphqlAppRepository(graphqlClient!);
    }
  }

  createOrderRepository(
    region: Region,
    graphqlClient?: GraphqlClient,
  ): SamdOrderRepository {
    if (this._repoBackend === RepoBackend.Fake) {
      return new SamdFakeOrderRepository();
    } else if (this._repoBackend === RepoBackend.Real) {
      if (!graphqlClient) {
        throw new GraphqlClientRequiredError();
      }
      return new SamdGraphqlOrderRepository(graphqlClient!, region);
    }

    throw new Error(`Invalid repository ${this._repoBackend}`);
  }

  createMemberRepository(graphqlClient?: GraphqlClient): MemberRepository {
    if (this._repoBackend === RepoBackend.Fake) {
      return new SamdFakeMemberRepository();
    } else if (this._repoBackend === RepoBackend.Real) {
      if (!graphqlClient) {
        throw new GraphqlClientRequiredError();
      }
      return super.createMemberRepository(graphqlClient);
    }

    throw new Error(`Invalid repository ${this._repoBackend}`);
  }

  createProstateBiopsyOrderDetailDisplayer(
    orderRepository: SamdOrderRepository,
  ): OrderDetailDisplayer {
    return new SamdProstateOrderDetailDisplayer(orderRepository);
  }
}
